module.exports = __webpack_public_path__ + "img/noData.24b90d9c.svg";